import React from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { ArrowRight, Calculator } from "lucide-react";

import { Button } from "../ui/button";

export function Hero() {
  const { t } = useTranslation();

  return (
    <section id="home" className="relative flex min-h-screen items-center justify-center pt-20">
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-cyan-100 via-white to-blue-50">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-20 mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/50 to-white" />
      </div>

      <div className="container z-10 mx-auto px-4 text-center">
        <h1 className="mb-6 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl md:text-7xl">
          {t("hero.title")}
          <br />
          <span className="bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
            {t("hero.highlight")}
          </span>
        </h1>
        <p className="mx-auto mb-8 max-w-2xl text-lg text-slate-600 sm:text-xl md:text-2xl">
          {t("hero.subtitle")} <strong>MB Floripa Turismo</strong>.
        </p>
        <div className="flex flex-col justify-center gap-3 sm:flex-row sm:gap-4">
          <Button size="lg" className="h-14 rounded-full px-8 text-lg shadow-lg shadow-primary/25" asChild>
            <Link to="/orcamento">
              <Calculator className="h-5 w-5" />
              {t("quote.heroCta")}
            </Link>
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="h-14 rounded-full border-slate-200 bg-white/70 px-8 text-lg text-slate-700 shadow-sm hover:bg-white hover:text-primary"
            asChild
          >
            <a href="#tours">
              {t("hero.secondary")} <ArrowRight className="h-5 w-5" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
